import React from 'react';

const CareerIntro = () => {
  return (
    <div className='courses_career_intro'>
      <p className='courses_career_intro_text'>
        Upon course completion, a diverse range of <span className='courses_career_intro_text_successful_career'>successful career</span> avenues beckons
      </p>
    </div>
  )
}

export default CareerIntro
